module.exports = __webpack_public_path__ + "static/alert-task-do-bf1015624c24c5f0c312052a82aef585.png";